export default __webpack_public_path__ + "static/media/new-hour-icon.2ec2f74e.svg";